
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.475 8.838a.548.548 0 00.551-.476.524.524 0 00-.526-.574h-.937a.413.413 0 01-.413-.413v-3.75a.413.413 0 01.413-.412h.912a.548.548 0 00.551-.476.524.524 0 00-.526-.574h-.937A1.462 1.462 0 00.1 3.625v3.75a1.462 1.462 0 001.463 1.463h.912zM7.525 8.838h.912A1.463 1.463 0 009.9 7.375v-3.75a1.46 1.46 0 00-1.463-1.462H7.5a.52.52 0 00-.341.917.545.545 0 00.366.133h.912a.412.412 0 01.413.412v3.75a.413.413 0 01-.413.413H7.5a.52.52 0 00-.341.917.545.545 0 00.366.133zM4.629.754a.525.525 0 01.896.371v8.75a.525.525 0 11-1.05 0v-8.75c0-.14.055-.273.154-.371z","fill":"#fff","stroke":"#fff","stroke-width":".2"}})])
          )
        }
      }
    